import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import './global.css';

import Login from './authentication/Login';
import Signup from './authentication/Signup';
import ForgotPassword from './authentication/ForgotPassword';
import ResetPassword from './authentication/ResetPassword';

import PrivateRoute from './components/PrivateRoute';
import DashboardLayout from './dashboard/DashboardLayout';

function App() {
  return (
    <Router>
      <Layout />
    </Router>
  );
}

const isAuthenticated = () => {
  return !!localStorage.getItem('accessToken');
};

function RootRedirect() {
  return <Navigate to={isAuthenticated() ? "/dashboard" : "/login"} replace />;
}

function Layout() {
  return (
    <div className="app">
      <div className="content-wrapper">
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Protected dashboard */}
          <Route
            path="/dashboard/*"
            element={
              <PrivateRoute>
                <DashboardLayout />
              </PrivateRoute>
            }
          />

          <Route path="/" element={<RootRedirect />} />

          <Route path="*" element={<RootRedirect />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;

